(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/pages/search-results.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/pages/search-results.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Searchbar = svs.grassroots.components.searchbar_section.Searchbar;
const SearchResultsList = svs.grassroots.components.search_results.SearchResultsList;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation,
  useHistory = _ReactRouterDOM.useHistory;
const Loader = svs.components.ReactLoader.Loader;
const _svs$ui = svs.ui,
  Button = _svs$ui.Button,
  Icon = _svs$ui.ReactIcon;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const SearchResults = _ref => {
  let _ref$resultPage = _ref.resultPage,
    resultPage = _ref$resultPage === void 0 ? false : _ref$resultPage;
  const _useLocation = useLocation(),
    search = _useLocation.search;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchterm = _useState2[0],
    setSearchterm = _useState2[1];
  const _useState3 = useState(5),
    _useState4 = _slicedToArray(_useState3, 2),
    numResponses = _useState4[0],
    setNumResponses = _useState4[1];
  const _grassrootsQueryApi$u = grassrootsQueryApi.useFetchReceiversSearchQuery({
      searchterm,
      numResponses
    }),
    data = _grassrootsQueryApi$u.data,
    isLoading = _grassrootsQueryApi$u.isLoading;
  const history = useHistory();
  useEffect(() => {
    if (search.includes('?q=')) {
      setSearchterm(decodeURIComponent(search.slice(3)));
    }
  }, []);
  const fetchReceiversHandler = e => e.preventDefault();
  const onChangeHandler = e => {
    setNumResponses(5);
    setSearchterm(e.currentTarget.value);
    if (!resultPage) {
      history.replace({
        pathname: 'sok',
        search: "?q=".concat(encodeURIComponent(e.currentTarget.value)),
        state: {
          isActive: true
        }
      });
    }
  };
  const fetchMoreClicked = () => {
    setNumResponses(50);
  };
  return React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "search-result-container f-content"
  }, React.createElement(CardBody, null, !resultPage && React.createElement(Button, {
    className: "btn-icon-left margin-top-1 search-result-back-button",
    onClick: () => history.push('/')
  }, React.createElement(Icon, {
    icon: "arrow-left",
    size: 100
  }), "Tillbaka"), React.createElement("div", {
    className: "search-result-body"
  }, React.createElement("h1", {
    className: "align-center"
  }, "S\xF6k f\xF6reningar h\xE4r"), React.createElement("p", {
    className: "align-center"
  }, "Du som valt f\xF6rening/-ar i Gr\xE4sroten f\xE5r automatiskt en avisering via e-post n\xE4r \xE5rets f\xF6rdelning \xE4r f\xE4rdig."), React.createElement("p", {
    className: "align-center margin-bottom-2"
  }, "Det kostar ingenting att vara med."), React.createElement(Searchbar, {
    displayResults: false,
    onChange: onChangeHandler,
    onSubmit: fetchReceiversHandler,
    searchResult: data === null || data === void 0 ? void 0 : data.receivers,
    searchterm: searchterm
  })), isLoading && !(data !== null && data !== void 0 && data.receivers) ? React.createElement(Loader, null) : Boolean(data === null || data === void 0 ? void 0 : data.receivers.length) && data.receivers.length > 0 && React.createElement("div", {
    className: "search-result-list margin-top-1"
  }, React.createElement("p", {
    className: "margin-left-1"
  }, "S\xF6kresultat f\xF6r:", searchterm, ' ', "- [", data.numberfound, "] matchningar."), React.createElement(SearchResultsList, {
    receivers: data.receivers,
    resultPage: true,
    searchterm: searchterm
  }), React.createElement("div", {
    className: "align-center w100 padding-bottom-4"
  }, numResponses < 50 && React.createElement(Button, {
    className: "fetch-more-btn",
    onClick: fetchMoreClicked,
    transparent: true
  }, "H\xE4mta fler")))));
};
svs.grassroots.pages.SearchResults = SearchResults;

 })(window);